module.exports = __webpack_public_path__ + "static/img/Bachelor_010735.84d8ceb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010735.jpg
// module id = 236
// module chunks = 0